"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTooltip = void 0;
var _Tooltip = require("./Tooltip");
// TODO: in v9, move styled() from Tooltip.jsx to here
var StyledTooltip = _Tooltip.Tooltip;
exports.StyledTooltip = StyledTooltip;